import { render, staticRenderFns } from "./ContactListPopover.vue?vue&type=template&id=65ad0035&scoped=true&"
import script from "./ContactListPopover.vue?vue&type=script&lang=js&"
export * from "./ContactListPopover.vue?vue&type=script&lang=js&"
import style0 from "./ContactListPopover.vue?vue&type=style&index=0&id=65ad0035&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ad0035",
  null
  
)

export default component.exports